<template>
  <div v-if="isRxHarmony" :class="[inline ? 'flex items-center gap-2' : 'fixed bottom-4 left-4 z-50 flex items-center gap-2 rounded-full bg-white/95 px-2 py-1 shadow-lg']">
    <span :class="['text-xs', dark ? 'text-lumen-off-white/55' : 'text-gray-500']">Design</span>
    <div :class="['inline-flex rounded-full border p-0.5', dark ? 'border-lumen-off-white/25 bg-white/10' : 'border-gray-300 bg-white']">
      <button
        v-for="option in options"
        :key="option.label"
        type="button"
        :class="['rounded-full px-3 py-1 text-xs font-medium transition-colors', pillClass(option)]"
        @click="select(option.value)"
      >
        {{ option.label }}
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    inline: Boolean,
    dark: Boolean,
  },
  data() {
    return {
      options: [
        { value: "v1", label: "Old" },
        { value: "v2", label: "New" },
      ],
    };
  },
  computed: {
    ...mapGetters("organization", ["portalVersion", "cobrandId"]),
    isRxHarmony() {
      return this.cobrandId === "rx-harmony";
    },
    current() {
      return this.portalVersion;
    },
  },
  methods: {
    pillClass(option) {
      const isCurrent = option.value === this.current;
      if (this.dark) return isCurrent ? "bg-lumen text-zen" : "text-lumen-off-white/70 hover:text-lumen-off-white";
      return isCurrent ? "bg-gray-800 text-white" : "text-gray-600 hover:text-gray-900";
    },
    select(version) {
      if (version === this.current) return;
      localStorage.setItem("portalVersion", version);
      window.location.reload();
    },
  },
};
</script>
